import { useGetBreakpoint } from '@moonpig/web-core-utils'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { useLocaleText } from '../../../locale'

export const useGetPlaceholderText = (isMobile: boolean): string => {
  const localiseText = useLocaleText()

  const isConciergeSearchExperimentEnabled = useExperiment('search-concierge', {
    fallback: false,
  })

  const currentBreakpoint = useGetBreakpoint()

  if (!isConciergeSearchExperimentEnabled) {
    return localiseText(
      isMobile ? 'search.placeholder_short' : 'search.placeholder_long',
    )
  }

  switch (currentBreakpoint) {
    case 'xs':
      return localiseText('search.placeholder_short')
    case 'sm':
      return localiseText('search.placeholder_mid')
    default:
      return localiseText('search.placeholder_long')
  }
}
